import React, { useEffect } from 'react';
import { FadeIn } from '../components/FadeIn';
import { CheckCircle2, Shield, FileText, Handshake } from 'lucide-react';
import { initMetaPixel, trackPageView, trackLead } from '../utils/metaPixel';
export function ThankYouPage() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
    trackLead();
  }, []);
  return <div className="min-h-screen bg-brand-black selection:bg-brand-gold selection:text-brand-black font-sans" data-id="element-212">
      {/* Section 1: Confirmation */}
      <section className="py-[60px] md:py-[100px] px-6" data-id="element-213">
        <div className="max-w-[900px] mx-auto text-center" data-id="element-214">
          <FadeIn data-id="element-215">
            <CheckCircle2 className="w-24 h-24 text-brand-green mx-auto mb-8" data-id="element-216" />
          </FadeIn>
          <FadeIn delay={0.2} data-id="element-217">
            <h1 className="text-[36px] md:text-[42px] font-bold text-white mb-8 leading-tight" data-id="element-218">
              ¡Gracias! Tu Solicitud Fue Recibida.
            </h1>
          </FadeIn>
          <FadeIn delay={0.3} data-id="element-219">
            <div className="text-[18px] md:text-[20px] text-white space-y-4 max-w-2xl mx-auto" data-id="element-220">
              <p data-id="element-221">
                Un agente licenciado te llamará en menos de 24 horas para darte
                tu cotización personalizada y responder todas tus preguntas.
              </p>
              <p className="text-white/80 pt-2" data-id="element-222">
                Sin presión. Sin compromiso. Solo información clara y honesta
                para proteger a tu familia.
              </p>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* Section 2: Guide Download */}
      <section className="py-[50px] md:py-[80px] px-6 bg-brand-darkGray border-y border-brand-gold/20" data-id="element-223">
        <div className="max-w-[900px] mx-auto text-center" data-id="element-224">
          <FadeIn data-id="element-225">
            <h2 className="text-[28px] md:text-[32px] font-bold text-brand-gold mb-6" data-id="element-226">
              Mientras Esperas, Descarga Tu Guía Gratuita
            </h2>
            <p className="text-[18px] md:text-[20px] text-white mb-10 max-w-2xl mx-auto" data-id="element-227">
              La Guía Paso a Paso Que Toda Familia Hispana Necesita Para el
              Momento Más Difícil.
            </p>
            <a href="https://gamma.app/docs/Programa-Funeral-Advantage-Los-Guardianes-Funerarios-dey0gxgnqcz0q3e" target="_blank" rel="noopener noreferrer" className="inline-block w-full sm:w-auto bg-brand-gold hover:bg-[#FFB733] text-black font-bold text-[18px] md:text-[20px] py-4 px-10 rounded-[10px] shadow-[0_4px_15px_rgba(245,166,35,0.4)] hover:shadow-[0_6px_20px_rgba(245,166,35,0.6)] transition-all duration-300 hover:-translate-y-0.5" data-id="element-228">
              ⬇️ SÍ, QUIERO DESCARGAR MI GUÍA GRATUITA AHORA
            </a>
          </FadeIn>
        </div>
      </section>

      {/* Section 3: Trust Reinforcement */}
      <section className="py-[50px] md:py-[80px] px-6 bg-brand-black" data-id="element-229">
        <div className="max-w-[900px] mx-auto" data-id="element-230">
          <FadeIn data-id="element-231">
            <div className="grid md:grid-cols-3 gap-8 text-center" data-id="element-232">
              <div className="flex flex-col items-center space-y-4 p-6" data-id="element-233">
                <Shield className="w-14 h-14 text-brand-gold" data-id="element-234" />
                <p className="text-white text-[16px] md:text-[18px] font-medium" data-id="element-235">
                  Compañías con 100+ años de historia
                </p>
              </div>
              <div className="flex flex-col items-center space-y-4 p-6" data-id="element-236">
                <FileText className="w-14 h-14 text-brand-gold" data-id="element-237" />
                <p className="text-white text-[16px] md:text-[18px] font-medium" data-id="element-238">
                  Regulado por el Departamento de Seguros
                </p>
              </div>
              <div className="flex flex-col items-center space-y-4 p-6" data-id="element-239">
                <Handshake className="w-14 h-14 text-brand-gold" data-id="element-240" />
                <p className="text-white text-[16px] md:text-[18px] font-medium" data-id="element-241">
                  Agentes licenciados y certificados
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* Section 4: What to Expect */}
      <section className="py-[50px] md:py-[80px] px-6 bg-brand-guarantee" data-id="element-242">
        <div className="max-w-[900px] mx-auto text-center" data-id="element-243">
          <FadeIn data-id="element-244">
            <h2 className="text-[28px] md:text-[32px] font-bold text-white mb-12" data-id="element-245">
              ¿Qué Pasa Ahora?
            </h2>
          </FadeIn>
          <FadeIn delay={0.2} data-id="element-246">
            <div className="grid md:grid-cols-3 gap-8 max-w-3xl mx-auto" data-id="element-247">
              <div className="bg-white/5 border border-white/10 rounded-2xl p-8 space-y-4" data-id="element-248">
                <span className="text-4xl" data-id="element-249">1️⃣</span>
                <p className="text-white text-[18px]" data-id="element-250">
                  Recibirás una llamada de un agente licenciado en menos de 24
                  horas
                </p>
              </div>
              <div className="bg-white/5 border border-white/10 rounded-2xl p-8 space-y-4" data-id="element-251">
                <span className="text-4xl" data-id="element-252">2️⃣</span>
                <p className="text-white text-[18px]" data-id="element-253">
                  Te explicará las opciones disponibles según tu edad y
                  situación
                </p>
              </div>
              <div className="bg-white/5 border border-white/10 rounded-2xl p-8 space-y-4" data-id="element-254">
                <span className="text-4xl" data-id="element-255">3️⃣</span>
                <p className="text-white text-[18px]" data-id="element-256">
                  Si decides avanzar, tu póliza puede estar activa el mismo día
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#050505] py-10 text-center px-6 border-t border-white/5" data-id="element-257">
        <div className="max-w-[900px] mx-auto space-y-4" data-id="element-258">
          <p className="text-[#666666] text-[12px] max-w-2xl mx-auto" data-id="element-259">
            Al enviar tu formulario autorizaste a un agente licenciado a
            contactarte por teléfono o correo electrónico para brindarte
            información sobre pólizas de seguro de vida Final Expense. No se
            requiere compra.
          </p>
          <p className="text-brand-lightGray/50 text-sm" data-id="element-260">
            © {new Date().getFullYear()} Final Expense Protection. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>
    </div>;
}